import { render, staticRenderFns } from "./ExpenseTypes.yaml?vue&type=template&id=50448018&component"
import script from "./ExpenseTypes.yaml?vue&type=script&lang=ts&component"
export * from "./ExpenseTypes.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports